<template>
    <div>
<!--        <tours-filters :filterdata='filterdata_list' :translations="translations" @filter_tours="filterTours"></tours-filters>-->
        <tours-card :tours='tours_list' :translations="translations"></tours-card>
    </div>
</template>

<script>
    export default {
        props: ['filterdata', 'translations', 'tours'],
        data() {
            return {
                tours_list: this.tours,
                filterdata_list: this.filterdata,
                lang: ""
            }
        },
        mounted() {
            // console.log(this.locale)
            this.lang = document.documentElement.lang;
        },
        methods: {
            filterTours (value) {
                axios({
                    url: '/'+this.lang+'/themed',
                    method: 'get',
                    params: {
                        'destinations': value.destinations,
                        'interests': value.interests,
                        'durations': value.durations,
                    }
                })
                .then( response => {
                    this.tours_list = response.data.tours
                    this.filterdata_list = response.data.filters
                })
                .catch( e => {
                    console.log(e)
                })
            }
        }
    }
</script>
